/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import useStyles from "./styles";
import CloseIcon from "@material-ui/icons/Close";
import Rating from "@material-ui/lab/Rating";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import DialogFeedBack from "./Components/DialogFeedBack";

import { Grid, IconButton, TextField } from "@material-ui/core";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { Images } from "config/images";
import { feedBackAction } from "store/actions/FeedBackPageAction";

const FeedBackPage = props => {
	const { feedBackAction, infoShop } = props;
	const business = infoShop?.business || "THOPHAT";
	const classes = useStyles();
	const [value, setValue] = useState(0);
	const [note, setNote] = useState("");
	const [isOpen, setIsOpen] = useState(false);
	const history = useHistory();

	const success = () => {
		setIsOpen(true);
	};

	const handleSubmit = () => {
		const params = {
			rating: value,
			feedback: note,
			shopId: infoShop?.id,
			business: business,
			success
		};
		feedBackAction(params);
	};

	return (
		<Grid style={{ background: "#ffffff", height: "100vh" }}>
			<Grid classes={{ root: classes.rootHeader }}>
				<Grid classes={{ root: classes.titleHeader }}>
					Liên hệ cho chúng tôi
				</Grid>
				<IconButton
					classes={{ root: classes.btnClose }}
					onClick={() => history.goBack()}
				>
					<CloseIcon />
				</IconButton>
			</Grid>
			<Grid classes={{ root: classes.root }}>
				<Grid style={{ textAlign: "center" }}>
					<img src={Images.logoFeedBack} alt={"logoFeedBack"} />
				</Grid>
				<Grid classes={{ root: classes.title }}>Gửi liên hệ</Grid>
				<Grid classes={{ root: classes.subTitle }}>
					Bạn có hài lòng với dịch vụ của chúng tôi không?
				</Grid>
				<Grid style={{ textAlign: "center", padding: 10 }}>
					<Rating
						name="customized-empty"
						value={value}
						onChange={(event, newValue) => {
							setValue(newValue);
						}}
						precision={0.5}
						size="large"
						emptyIcon={<StarBorderIcon fontSize="inherit" />}
					/>
				</Grid>
				<Grid classes={{ root: classes.subTitle }}>
					Hãy gửi nội dung cần liên hệ!
				</Grid>
				<TextField
					multiline
					maxRows={5}
					minRows={5}
					value={note}
					onChange={event => {
						setNote(event.target.value);
					}}
					className={classes.textArea}
				/>
				<Grid container justifyContent="center">
					<Grid
						classes={{ root: classes.btnSubmit }}
						onClick={() => handleSubmit()}
					>
						Gửi
					</Grid>
				</Grid>
			</Grid>
			<DialogFeedBack
				open={isOpen}
				handleClose={() => {
					setIsOpen(false);
				}}
				handleConfirm={() => {
					history.goBack();
				}}
			/>
		</Grid>
	);
};

const mapStateToProps = state => {
	return {
		infoShop: state.homePageReducer.infoShop
	};
};

const mapDispatchToProps = dispatch => {
	return {
		feedBackAction: data => {
			dispatch(feedBackAction(data));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedBackPage);
